import styled from 'styled-components'

export function ContentList({ children }: { children: any }) {
  return <List>{children}</List>
}

const List = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 32px;
  column-gap: 8px;
  padding: 16px;
`
